import { render } from "./Logout.vue?vue&type=template&id=c90681b0&scoped=true&ts=true&lang=pug"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"

import "./Logout.vue?vue&type=style&index=0&id=c90681b0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c90681b0"]])

export default __exports__